<template>
 <div class="job_detail">
   <NavDetai/>
   <div style="margin-top: 45px"></div>
   <Breadcrumb/>
   <section class="position_container" :style="{minHeight:winHeight}">
       <div class="postion">{{PositonDetail.positionTitle}}</div>
       <div class="postion_desc">
          <table>
            <tr>
               <td>
                 <span class="key">工作地点：</span>
                 <span class="val">{{PositonDetail.location}}</span>
               </td>
               <td>
                 <span  class="key">招聘人数：</span>
                 <span class="val">{{PositonDetail.recruitNum}}</span>
               </td>
               <td>
                 <span  class="key">职位类别：</span>
                 <span class="val">{{PositonDetail.positionType}}</span>
               </td>
               <td>
                 <span  class="key">工作年限：</span>
                 <span class="val">{{PositonDetail.workLife}}</span>
               </td>
            </tr>
            <tr>
              <td>
                <span  class="key">学历要求：</span>
                <span class="val">{{PositonDetail.academicRequire}}</span>
              </td>
              <td>
                <span  class="key">所属部门：</span>
                <span  class="val">{{PositonDetail.positionType}}</span>
              </td>
              <td>
                <span  class="key">薪酬范围：</span>
                <span class="val">{{PositonDetail.salaryRange}}</span>
              </td>
              <td>
                <span  class="key">发布时间：</span>
                <span class="val">{{PositonDetail.releaseDate}}</span>
              </td>
            </tr>
          </table>
       </div>
      <div class="desc_wapper">
         <div class="description">
            <div class="title">岗位描述：</div>
            <div class="content" v-html="PositonDetail.positionDesc">
            </div>
         </div>
         <div class="requirement">
            <div class="title">岗位要求：</div>
            <div class="content" v-html="PositonDetail.positionRequire">
            </div>
         </div>
      </div>
     <div class="apply_container">
       <a  class="apply" href="https://www.zhipin.com/gongsi/5b475d38ad826f9c0HB92dq-Ew~~.html">投递简历</a>
       <!--<el-button  class="apply" v-popover:popover2>投递简历</el-button>-->
     </div>

     <!--<el-popover-->
       <!--ref="popover2"-->
       <!--placement="top"-->
       <!--title="求职提示："-->
       <!--width="220"-->
       <!--trigger="click"-->
       <!--content="请发送邮箱到:zhbgs@fnpsy.com">-->
     <!--</el-popover>-->

   </section>


 </div>
</template>

<script>
  import NavDetai from '@/components/NavDetai.vue';
  import  BreadDetail from '@/components/BreadDetail.vue';
  import  Breadcrumb from '@/components/Breadcrumb.vue';
  import { GetPositonDetail } from './JobDetail.model'
    export default {
        name: "JobDetail",
      components:{
          NavDetai,
        BreadDetail,
        Breadcrumb
        },
      metaInfo: {
        title: '福建省越盛智能科技有限公司', // set a title
        meta: [{                 // set meta
          name: '越盛智能、全自动智能布料小车、无功补偿、无人值守智能称重、视觉智能检测、能源在线监测、智能配料、自动喂料系统、自动喂养系统、智能饲养系统、养猪场喂料设备、养鸡场自动喂料系统、自动化养殖设备、智能喂养系统、智能称重喂养系统、自动称重喂养设备',
          content: '职位详情'
        }],
        link: [{                 // set link
          rel: 'asstes',
          href: 'http://www.fjyszn.com/'
        }]
      },
      beforeRouteUpdate (to, from, next) {
        //   console.log("fsdfsdf");
        // console.log(to);
        // console.log(from);
        // console.log(next);
      },
      async mounted(){
        this.srollToTotp();
        var posId = this.$route.query.posId;
        let PositonDetailData = await GetPositonDetail(posId);
        this.PositonDetail = PositonDetailData.data;
      },
      created(){
            this.getHeight();
      },
      data(){
          return{
            PositonDetail:{},
            winHeight:""
          }
      },
      methods:{
        getHeight(){
          this.winHeight =  window.innerHeight-182+'px';
        },
        srollToTotp() {
          window.pageYOffset ? window.pageYOffset = 0 : document.documentElement.scrollTop ? document.documentElement.scrollTop =
            0 : document.body.scrollTop ? document.body.scrollTop = 0 : null;
        }
      }
    }
</script>

<style scoped lang="less">
  .job_detail{

  }
  .position_container{
     width: 1240px;
     margin: 0px auto 120px;
    border:1px solid #E6E6E6;
  }
  .postion{
    background:#E6E6E6;
    height: 92px;
    line-height: 92px;
    border:1px solid rgba(230,230,230,1);
    text-align: left;
    font-size:26px;
    font-weight:600;
    color:rgba(51,51,51,1);
    text-indent: 30px;
  }
  .desc_wapper{
     padding: 30px;
  }
  .title{
    font-size:20px;
    font-weight:600;
    color:rgba(51,51,51,1);
    line-height:24px;
    text-align: left;
    margin-bottom: 18px;
  }
  .content{
    font-size:14px;
    font-weight:400;
    color:rgba(128,128,128,1);
    line-height:33px;
  }
  .description{
      margin-top: 16px;
      padding: 0px 0px 50px;
      border-bottom: 1px solid #E6E6E6;
     text-align: left;
  }
  .requirement{
       text-align: left;
       padding: 50px 0px;
       /*border-bottom: 1px solid #E6E6E6;*/
       /*margin-top: 16px;*/
  }
  .postion_desc{
    text-align: left;
     table{
        width: 100%;
        td{
          line-height: 75px;
          border-bottom:1px solid #E6E6E6;
          border-right:1px solid #E6E6E6;
          text-align: left;
          text-indent: 32px;
          color:rgba(51,51,51,1);
          font-size:14px;
          font-weight:400;
        }
       .key{
         font-size:14px;
         font-weight:600;
         color:rgba(51,51,51,1);
       }
       tr{
         &:last-child{
           border-right:none;
         }
       }
     }
  }
  .apply_container{
     border-top: 1px solid #E6E6E6;
  }
.apply{
  width:358px!important;
  background:linear-gradient(45deg,rgba(40,165,231,1) 0%,rgba(107,218,252,1) 100%);
  box-shadow:0px 9px 14px -8px rgba(57,178,236,0.6);
  border-radius:30px;
  line-height: 60px!important;
   height: 60px!important;
  text-align: center;
  margin: 34px auto;
  font-size:20px;
  font-weight:600;
  color:#fff;
  border-top: 1px solid #E6E6E6;
   display: block;
  &:hover{
     text-decoration: none;
  }
  &:active{
    border:none;
    box-shadow:none
  }
}
</style>
